export const Resources = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6385_3141)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.82593 3.09374C1.82593 2.4425 2.35387 1.91458 3.00509 1.91458H4.92176C5.57298 1.91458 6.10093 2.4425 6.10093 3.09374V12.6771C6.10093 13.3283 5.57303 13.8563 4.92176 13.8563H3.00509C2.35383 13.8563 1.82593 13.3283 1.82593 12.6771V3.09374ZM3.22593 3.31458V12.4563H4.70093V3.31458H3.22593Z"
          fill="#706A85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.82593 5.01041C1.82593 4.62381 2.13933 4.31041 2.52593 4.31041H5.40093C5.78753 4.31041 6.10093 4.62381 6.10093 5.01041C6.10093 5.39701 5.78753 5.71041 5.40093 5.71041H2.52593C2.13933 5.71041 1.82593 5.39701 1.82593 5.01041Z"
          fill="#706A85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.70093 3.09374C4.70093 2.4425 5.22887 1.91458 5.88009 1.91458H7.79675C8.44798 1.91458 8.97595 2.44247 8.97595 3.09374V12.6771C8.97595 13.3283 8.44802 13.8563 7.79675 13.8563H5.88009C5.22883 13.8563 4.70093 13.3283 4.70093 12.6771V3.09374ZM6.10093 3.31458V12.4563H7.57595V3.31458H6.10093Z"
          fill="#706A85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.70093 10.7604C4.70093 10.3738 5.01433 10.0604 5.40093 10.0604H8.27595C8.66255 10.0604 8.97595 10.3738 8.97595 10.7604C8.97595 11.147 8.66255 11.4604 8.27595 11.4604H5.40093C5.01433 11.4604 4.70093 11.147 4.70093 10.7604Z"
          fill="#706A85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9096 2.61691C11.7407 1.98656 11.0927 1.61298 10.4628 1.7818L11.9096 2.61691ZM11.9096 2.61691L14.4012 11.9128C14.4012 11.9128 14.4012 11.9128 14.4012 11.9128C14.5702 12.5429 14.1961 13.1905 13.5663 13.3595L11.707 13.8579C11.707 13.8579 11.707 13.8579 11.707 13.8579C11.0766 14.0268 10.4292 13.6525 10.2602 13.0229L7.76852 3.72687C7.59983 3.09687 7.9736 2.44905 8.60366 2.28014L10.4628 1.7818M9.17744 3.57577L11.5558 12.449L12.9923 12.0639L10.614 3.19071L9.17744 3.57577ZM11.5235 13.1736L11.4011 12.7169L11.5235 13.1736Z"
          fill="#706A85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3672 9.90342C13.4619 10.2782 13.2349 10.6589 12.8601 10.7536L10.8162 11.2703C10.4414 11.3651 10.0607 11.138 9.96598 10.7632C9.87123 10.3884 10.0983 10.0078 10.4731 9.91303L12.517 9.39633C12.8918 9.30158 13.2724 9.52861 13.3672 9.90342Z"
          fill="#706A85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3543 4.47031C12.4541 4.8438 12.2323 5.22749 11.8588 5.32731L9.07963 6.07002C8.70614 6.16983 8.32245 5.94797 8.22264 5.57448C8.12282 5.20099 8.34468 4.8173 8.71817 4.71749L11.4973 3.97477C11.8708 3.87496 12.2545 4.09682 12.3543 4.47031Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_6385_3141">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
